var q = Object.defineProperty;

var i = function i(e, o) {
  return q(e, "name", {
    value: o,
    configurable: !0
  });
};

import * as r from "react";
import { localStorageStore as E } from "ra-core";
import { AdminUI as M, AdminContext as N } from "ra-ui-materialui";
import O from "ra-language-english";
import w from "ra-i18n-polyglot";
var m = w(function () {
  return O;
}, "en", {
  allowMissing: !0
});
var R = i(function (e) {
  var o = e.authProvider,
      d = e.basename,
      s = e.catchAll,
      l = e.children,
      p = e.dashboard,
      u = e.dataProvider,
      f = e.disableTelemetry,
      c = e.history,
      h = e.i18nProvider,
      P = e.layout,
      A = e.loading,
      t = e.loginPage,
      y = e.menu,
      g = e.notification,
      v = e.queryClient,
      x = e.requireAuth,
      C = e.store,
      b = e.ready,
      T = e.theme,
      _e$title = e.title,
      I = _e$title === void 0 ? "React Admin" : _e$title;
  return t === !0 && process.env.NODE_ENV !== "production" && console.warn("You passed true to the loginPage prop. You must either pass false to disable it or a component class to customize it"), r.createElement(N, {
    authProvider: o,
    basename: d,
    dataProvider: u,
    i18nProvider: h,
    store: C,
    history: c,
    queryClient: v,
    theme: T
  }, r.createElement(M, {
    layout: P,
    dashboard: p,
    disableTelemetry: f,
    menu: y,
    catchAll: s,
    title: I,
    loading: A,
    loginPage: t,
    notification: g,
    requireAuth: x,
    ready: b
  }, l));
}, "Admin");
R.defaultProps = {
  i18nProvider: m,
  store: E()
};
export * from "ra-core";
export * from "ra-ui-materialui";
export { R as Admin, m as defaultI18nProvider };